<div class="card">

    <!-- Header -->
    <div class="flex justify-content-between align-items-center mb-4">
        <div>
            <h2 class="m-0 mb-2">Dashboard de Aprovações</h2>
            <p class="text-600 m-0">Gerencie as solicitações de aprovação do sistema</p>
        </div>
        <p-button icon="pi pi-refresh" label="Atualizar" [outlined]="true" severity="secondary"
                  (onClick)="atualizarAbaAtual()"></p-button>
    </div>

    <!-- Sistema de Abas -->
    <p-tabView [(activeIndex)]="abaAtiva" (onChange)="onMudarAba($event)">

        <!-- Aba: Pendente Minha Aprovação -->
        <p-tabPanel *ngIf="isAprovador">
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-inbox"></i>
                    <span>Pendente Minha Aprovação</span>
                    <p-tag [value]="contarPendenteAprovacao().toString()" severity="warning" *ngIf="contarPendenteAprovacao() > 0"></p-tag>
                </div>
            </ng-template>

            <!-- Filtros -->
            <div class="card mb-3 p-3 bg-gray-50">
        <div class="grid">
            <div class="col-12 md:col-3">
                <label for="filtroStatus" class="block mb-2 font-semibold text-sm">Status</label>
                <p-dropdown
                    id="filtroStatus"
                    [options]="statusOptions"
                    [(ngModel)]="filtroStatus"
                    placeholder="Todos os status"
                    [showClear]="true"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full">
                </p-dropdown>
            </div>
            <div class="col-12 md:col-3">
                <label for="filtroTipo" class="block mb-2 font-semibold text-sm">Tipo</label>
                <p-dropdown
                    id="filtroTipo"
                    [options]="tipoOptions"
                    [(ngModel)]="filtroTipo"
                    placeholder="Todos os tipos"
                    [showClear]="true"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full">
                </p-dropdown>
            </div>
            <div class="col-12 md:col-4">
                <label for="filtroBusca" class="block mb-2 font-semibold text-sm">Buscar</label>
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        id="filtroBusca"
                        type="text"
                        pInputText
                        [(ngModel)]="filtroBusca"
                        placeholder="Buscar por identificador, solicitante..."
                        class="w-full">
                </span>
            </div>
            <div class="col-12 md:col-2 flex align-items-end">
                <p-button
                    label="Limpar Filtros"
                    icon="pi pi-filter-slash"
                    [text]="true"
                    severity="secondary"
                    (onClick)="limparFiltros()"
                    styleClass="w-full">
                </p-button>
            </div>
        </div>
    </div>

            <!-- Tabela -->
    <p-table
        [value]="requisicoesFiltradas()"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} requisições"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        [tableStyle]="{'min-width': '60rem'}">

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="identificador">
                    # Requisição <p-sortIcon field="identificador"></p-sortIcon>
                </th>
                <th pSortableColumn="entidade">
                    Tipo <p-sortIcon field="entidade"></p-sortIcon>
                </th>
                <th pSortableColumn="solicitante">
                    Solicitante <p-sortIcon field="solicitante"></p-sortIcon>
                </th>
                <th pSortableColumn="criadoEm">
                    Data <p-sortIcon field="criadoEm"></p-sortIcon>
                </th>
                <th pSortableColumn="status">
                    Status <p-sortIcon field="status"></p-sortIcon>
                </th>
                <th>Justificativa</th>
                <th style="width: 12rem">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-requisicao>
            <tr>
                <td>
                    <span class="font-semibold text-primary">#{{ requisicao.identificador }}</span>
                </td>
                <td>{{ requisicao.entidade }}</td>
                <td>
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-user text-500"></i>
                        <span>{{ requisicao.solicitante }}</span>
                    </div>
                </td>
                <td>
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-calendar text-500"></i>
                        <span>{{ requisicao.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</span>
                    </div>
                </td>
                <td>
                    <app-tag-status [status]="requisicao.status"></app-tag-status>
                </td>
                <td>
                    <span class="text-overflow-ellipsis overflow-hidden white-space-nowrap"
                          style="max-width: 200px; display: inline-block;"
                          [pTooltip]="requisicao.justificativa"
                          tooltipPosition="top">
                        {{ requisicao.justificativa || '-' }}
                    </span>
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button
                            *ngIf="requisicao.status === 'PENDENTE' && isAprovador"
                            icon="pi pi-check"
                            [rounded]="true"
                            [text]="true"
                            severity="success"
                            [loading]="loadingAprovacao"
                            (onClick)="aprovar(requisicao)"
                            pTooltip="Aprovar"
                            tooltipPosition="top">
                        </p-button>
                        <p-button
                            *ngIf="requisicao.status === 'PENDENTE' && isAprovador"
                            icon="pi pi-times"
                            [rounded]="true"
                            [text]="true"
                            severity="danger"
                            [loading]="loadingAprovacao"
                            (onClick)="reprovar(requisicao)"
                            pTooltip="Rejeitar"
                            tooltipPosition="top">
                        </p-button>
                        <p-button
                            icon="pi pi-eye"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            [routerLink]="['/workflow/requisicao', requisicao.id]"
                            pTooltip="Visualizar detalhes"
                            tooltipPosition="top">
                        </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-5">
                    <div class="flex flex-column align-items-center gap-3">
                        <i class="pi pi-inbox text-6xl text-400"></i>
                        <p class="text-xl text-600 m-0">Nenhuma requisição encontrada</p>
                        <p class="text-500 m-0">Não há requisições que correspondam aos filtros aplicados</p>
                    </div>
                </td>
            </tr>
        </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- Aba: Minhas Solicitações -->
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-send"></i>
                    <span>Minhas Solicitações</span>
                    <p-tag [value]="contarMinhasSolicitacoes().toString()" severity="info" *ngIf="contarMinhasSolicitacoes() > 0"></p-tag>
                </div>
            </ng-template>

            <!-- Filtros -->
            <div class="card mb-3 p-3 bg-gray-50">
                <div class="grid">
                    <div class="col-12 md:col-3">
                        <label for="filtroStatus2" class="block mb-2 font-semibold text-sm">Status</label>
                        <p-dropdown
                            id="filtroStatus2"
                            [options]="statusOptions"
                            [(ngModel)]="filtroStatus"
                            placeholder="Todos os status"
                            [showClear]="true"
                            optionLabel="label"
                            optionValue="value"
                            styleClass="w-full">
                        </p-dropdown>
                    </div>
                    <div class="col-12 md:col-3">
                        <label for="filtroTipo2" class="block mb-2 font-semibold text-sm">Tipo</label>
                        <p-dropdown
                            id="filtroTipo2"
                            [options]="tipoOptions"
                            [(ngModel)]="filtroTipo"
                            placeholder="Todos os tipos"
                            [showClear]="true"
                            optionLabel="label"
                            optionValue="value"
                            styleClass="w-full">
                        </p-dropdown>
                    </div>
                    <div class="col-12 md:col-4">
                        <label for="filtroBusca2" class="block mb-2 font-semibold text-sm">Buscar</label>
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-search"></i>
                            <input
                                id="filtroBusca2"
                                type="text"
                                pInputText
                                [(ngModel)]="filtroBusca"
                                placeholder="Buscar por identificador..."
                                class="w-full">
                        </span>
                    </div>
                    <div class="col-12 md:col-2 flex align-items-end">
                        <p-button
                            label="Limpar Filtros"
                            icon="pi pi-filter-slash"
                            [text]="true"
                            severity="secondary"
                            (onClick)="limparFiltros()"
                            styleClass="w-full">
                        </p-button>
                    </div>
                </div>
            </div>

            <!-- Tabela -->
            <p-table
                [value]="requisicoesFiltradas()"
                [loading]="loading"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} requisições"
                styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
                [tableStyle]="{'min-width': '60rem'}">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="identificador">
                            # Requisição <p-sortIcon field="identificador"></p-sortIcon>
                        </th>
                        <th pSortableColumn="entidade">
                            Tipo <p-sortIcon field="entidade"></p-sortIcon>
                        </th>
                        <th pSortableColumn="solicitante">
                            Solicitante <p-sortIcon field="solicitante"></p-sortIcon>
                        </th>
                        <th pSortableColumn="criadoEm">
                            Data <p-sortIcon field="criadoEm"></p-sortIcon>
                        </th>
                        <th pSortableColumn="status">
                            Status <p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th>Justificativa</th>
                        <th style="width: 12rem">Ações</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-requisicao>
                    <tr>
                        <td>
                            <span class="font-semibold text-primary">#{{ requisicao.identificador }}</span>
                        </td>
                        <td>{{ requisicao.entidade }}</td>
                        <td>
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-user text-500"></i>
                                <span>{{ requisicao.solicitante }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-calendar text-500"></i>
                                <span>{{ requisicao.criadoEm | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </div>
                        </td>
                        <td>
                            <app-tag-status [status]="requisicao.status"></app-tag-status>
                        </td>
                        <td>
                            <span class="text-overflow-ellipsis overflow-hidden white-space-nowrap"
                                  style="max-width: 200px; display: inline-block;"
                                  [pTooltip]="requisicao.justificativa"
                                  tooltipPosition="top">
                                {{ requisicao.justificativa || '-' }}
                            </span>
                        </td>
                        <td>
                            <div class="flex gap-2">
                                <!-- <p-button
                                    *ngIf="requisicao.status === 'PENDENTE' && isAprovador(requisicao)"
                                    icon="pi pi-check"
                                    [rounded]="true"
                                    [text]="true"
                                    severity="success"
                                    [loading]="loadingAprovacao"
                                    (onClick)="aprovar(requisicao)"
                                    pTooltip="Aprovar"
                                    tooltipPosition="top">
                                </p-button>
                                <p-button
                                    *ngIf="requisicao.status === 'PENDENTE' && isAprovador"
                                    icon="pi pi-times"
                                    [rounded]="true"
                                    [text]="true"
                                    severity="danger"
                                    [loading]="loadingAprovacao"
                                    (onClick)="reprovar(requisicao)"
                                    pTooltip="Rejeitar"
                                    tooltipPosition="top">
                                </p-button> -->
                                <p-button
                                    icon="pi pi-eye"
                                    [rounded]="true"
                                    [text]="true"
                                    severity="info"
                                    [routerLink]="['/workflow/requisicao', requisicao.id]"
                                    pTooltip="Visualizar detalhes"
                                    tooltipPosition="top">
                                </p-button>

                                <p-button
                                    *ngIf="requisicao.status === 'PENDENTE' && !isAprovador"
                                    icon="pi pi-trash"
                                    [rounded]="true"
                                    [text]="true"
                                    severity="danger"
                                    [loading]="loadingAprovacao"
                                    (onClick)="cancelarRequisicao(requisicao)"
                                    pTooltip="Cancelar"
                                    tooltipPosition="top">
                                </p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="text-center p-5">
                            <div class="flex flex-column align-items-center gap-3">
                                <i class="pi pi-inbox text-6xl text-400"></i>
                                <p class="text-xl text-600 m-0">Nenhuma requisição encontrada</p>
                                <p class="text-500 m-0">Você ainda não criou nenhuma solicitação</p>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>

    </p-tabView>
</div>

<p-confirmDialog [visible]="false" header="Confirmation" width="425"></p-confirmDialog>

<p-dialog 
  [(visible)]="displayDialog" 
  header="Reprovação da Requisição" 
  [modal]="true" 
  [style]="{width: '500px'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="cancelarReprovacao()">
  
  <div class="p-fluid">
    <p class="mb-3" *ngIf="requisicaoSelecionada">
      Você realmente deseja reprovar a requisição: # {{ requisicaoSelecionada.identificador }}?
    </p>
    
    <div class="field">
      <label for="justificativa">Justificativa *</label>
      <textarea 
        id="justificativa" 
        pInputTextarea 
        [(ngModel)]="justificativa" 
        rows="3"
        [class.p-invalid]="mostrarErro && !justificativa"
        placeholder="Digite uma justificativa">
      </textarea>
      <small class="p-error" *ngIf="mostrarErro && !justificativa">
        Campo obrigatório
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button 
      label="Cancelar" 
      icon="pi pi-times" 
      severity="secondary"
      (onClick)="cancelarReprovacao()">
    </p-button>
    <p-button 
      label="Confirmar" 
      icon="pi pi-check" 
      (onClick)="reprovacao()">
    </p-button>
  </ng-template>
</p-dialog>